import { useCallback, useMemo } from 'react';

import { SortDirection } from '../types';

type UseTableSortParams = {
  direction: string | null;
  onDirectionChange: (direction: SortDirection) => void;
};

export function useTableSort({
  direction,
  onDirectionChange
}: UseTableSortParams) {
  const sortDescriptor = useMemo(() => {
    if (!direction || direction === 'DESC') {
      return { column: 'timestamp', direction: 'descending' as const };
    }
    return { column: 'timestamp', direction: 'ascending' as const };
  }, [direction]);

  const handleSortChange = useCallback(
    (descriptor: {
      column: string | number;
      direction: 'ascending' | 'descending';
    }) => {
      if (descriptor.column === 'timestamp') {
        const newDirection =
          descriptor.direction === 'descending' ? 'DESC' : 'ASC';
        onDirectionChange(newDirection);
      }
    },
    [onDirectionChange]
  );

  return {
    sortDescriptor,
    handleSortChange
  };
}
